import * as React from 'react';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuggestModalMobileHeader = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "suggest-modal-mobile-header",
    className: styles['header'],
    ref: ref,
    children: props.children
  });
});
SuggestModalMobileHeader.displayName = 'SuggestModalMobileHeader';